<template>
    <v-tooltip v-bind="tooltipOptions" v-model="show">
        <template #activator="{ on }">
            <span v-on="on" class="d-inline-block">
                <v-btn flat icon :color="color" :class="cls"
                       :disabled="!hasAccess"
                       :href="href"
                       @click="e => $emit('click', e)">
                    <v-icon v-bind="iconOptions">{{icon}}</v-icon>
                </v-btn>
            </span>
        </template>
        <span v-if="hasAccess"><slot></slot></span>
        <span v-else v-html="trans(noPermissionToolTip !== '' && isUserActive ? noPermissionToolTip : 'app.no_access_tooltip')"></span>
    </v-tooltip>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    data: () => ({
      show: false,
    }),
    props: {
      color: String,
      cls: String,
      icon: String,
      href: {
        type: String,
        required: false,
      },
      iconOptions: {
        type: Object,
        required: false,
        default: () => {
        },
      },
      permission: {
        type: [String, Function, Boolean],
        required: false,
        default: () => null,
      },
      tooltip: {
        type: Object,
        required: false,
        default: () => {
        },
      },
      noPermissionToolTip: {
          type: String,
          default: ''
      }
    },
      computed: {
      ...mapGetters([
        'hasPermission',
        'isUserActive'
      ]),

      hasAccess() {
        if (typeof this.permission === 'string') {
          return this.hasPermission(this.permission);
        }

        if (typeof this.permission === 'boolean') {
          return this.permission;
        }

        if (typeof this.permission === 'function') {
          return this.permission(this.hasPermission);
        }

        return true;
      },

      tooltipOptions() {
        const defaults = {
          'bottom': true,
          'attach': true,
          'offset-overflow': true,
          'lazy': true,
          ...this.tooltip,
        };

        if (this.hasAccess) {
          return defaults;
        }

        return {
          'close-delay': 2000,
          'max-width': 300,
          ...defaults,
        };
      },
    },
  };
</script>

<style lang="scss" type="text/scss">
    .v-tooltip__content span {
        text-align: left;
        display: block;
        width: 100%;
    }
     .combined-patient-dialog-button {
       margin: 0 !important;
       width: 16px !important;
       height: 16px !important;
     }
</style>
